export const PAYMENT_PAGE_LOAD_REQUESTED = 'PAYMENT_PAGE_LOAD_REQUESTED';
export const PAYMENT_PAGE_LOAD_SUCCEEDED = 'PAYMENT_PAGE_LOAD_SUCCEEDED';
export const PAYMENT_PAGE_LOAD_FAILED = 'PAYMENT_PAGE_LOAD_FAILED';
export const PAYMENT_PAGE_LOAD_REQUESTED_AFTER_LOGIN = 'PAYMENT_PAGE_LOAD_REQUESTED_AFTER_LOGIN';
export const CAMPAIGN_UPDATE_STATE = 'CAMPAIGN_UPDATE_STATE';

export function loadPaymentPageRequest() {
  return {
    type: PAYMENT_PAGE_LOAD_REQUESTED,
  };
}

export function campaignUpdateState(selectedState) {
  return {
    type: CAMPAIGN_UPDATE_STATE,
    payload: {
      selectedState,
    },
  };
}

export function loadPaymentPageRequestAfterLogin(selectedState) {
  return {
    type: PAYMENT_PAGE_LOAD_REQUESTED_AFTER_LOGIN,
    payload: {
      selectedState,
    },
  };
}

export function loadPaymentPageSuccess() {
  return {
    type: PAYMENT_PAGE_LOAD_SUCCEEDED,
  };
}

export function loadPaymentPageFailure() {
  return {
    type: PAYMENT_PAGE_LOAD_FAILED,
  };
}

